import { EditInternalGroupDataValue } from '../../../typings/groupsEditState';
import {
    ClientErrorsConfigRule,
    EditGroupValidationParams
} from '../ClientGroupEditErrors/ClientGroupEditErrors';
import { GroupValidationSchema } from '../GroupValidationSchema/GroupValidationSchema';

interface ClientErrorInternalGroupRules<
    K extends keyof EditInternalGroupDataValue
> {
    rules: Array<ClientErrorsConfigRule<K>>;
}

export class InternalGroupValidationSchema extends GroupValidationSchema {
    protected getClientErrorsConfig(
        params: EditGroupValidationParams
    ): Partial<
        {
            [K in keyof EditInternalGroupDataValue]: ClientErrorInternalGroupRules<
                K
            >
        }
    > {
        return {
            level: {
                rules: [
                    {
                        code: 'required',
                        validate: (value: string): boolean => {
                            return Boolean(value);
                        },
                        text: 'Level is required'
                    }
                ]
            }
        };
    }
}
